export default class Registration {
  public userId: string;
  public firstName: string;
  public lastName: string;
  public permitNumber: string;
  public password: string;

  constructor({
    userId = '',
    firstName = '',
    lastName = '',
    permitNumber = '',
    password = '',
  }) {
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.permitNumber = permitNumber;
    this.password = password;
  }
}
export const EmptyRegistration = new Registration({});
